// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__X6CRt","head":"Table_head__3UJMy","col":"Table_col__21PIO"};